import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrame } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_openimg() {
  // TIFF image stored as base64 encoded string
  var data =
    "SUkqAEwBAAAmoLYKkpuV///y3DIwRg/LdOpV5Uf///////Bf/wf//////y3DKOPxEf//////" +
    "/////////////////////////////////////////////////zsTA8NT5WxP////+d4zhGD/" +
    "weVeVH//////////yOv////////////BDjj/xEf////////////8pa/0/8MPwAQAQCao7E0T" +
    "OIkl8N/7f+3/t/7f+3/t///t///lW2////b///xf/v////3///v//8igL/+P//////1//+v/" +
    "///1/r//+l//+l/lW//0v///S/xS/0v9L/S/0v9L/CX+EF/1/j//////////////////////" +
    "///H4/////////////////////////////////////gAgAgmqX//////////////////////" +
    "/////+MAEAERAP4ABAABAAAAAAAAAAABAwABAAAALAEAAAEBAwABAAAALAEAAAIBAwABAAAA" +
    "AQAAAAMBAwABAAAABAAAAAYBAwABAAAAAAAAAA0BAgAiAAAARgIAABEBBAADAAAAOgIAABIB" +
    "AwABAAAAAQAAABUBAwABAAAAAQAAABYBAwABAAAAgAAAABcBBAADAAAALgIAABoBBQABAAAA" +
    "HgIAABsBBQABAAAAJgIAABwBAwABAAAAAQAAACgBAwABAAAAAgAAAFMBAwABAAAAAQAAAAAA" +
    "AAAsAQAAAQAAACwBAAABAAAAlQAAAJQAAAAbAAAACAAAAJ0AAAAxAQAAQzpcVXNlcnNcamhh" +
    "cnRlclxEZXNrdG9wXHRlc3QudGlmAA==";

  LwAPI?.openImageFromBase64(data).then(function (result) {
    if (result.error !== null) alert(result.msg);
  });
}

function ex_fitimg(x: number, y: number, d: number) {
  LwAPI?.fitInImage(x, y, d);
}

document.getElementById("openimg")?.addEventListener("click", async () => {
  await apiReady;
  ex_openimg();
});
document.getElementById("fitin1")?.addEventListener("click", async () => {
  await apiReady;
  ex_fitimg(150, 150, 100);
});
document.getElementById("fitin2")?.addEventListener("click", async () => {
  await apiReady;
  ex_fitimg(150, 150, 300);
});
document.getElementById("fitin3")?.addEventListener("click", async () => {
  await apiReady;
  ex_fitimg(300, 0, 50);
});
